import { ScreenData } from "../types/ScreenTypes";

type PrayerNames = Partial<ScreenData["customizedNames"]>;

// The backend sends these when a masjid hasn't set its own name.
const DEFAULT_NAMES: Record<string, string> = {
  fajr: "Fajr",
  sunrise: "Sunrise",
  dhuhr: "Dhuhr",
  asar: "Asar",
  maghrib: "Maghrib",
  isha: "Isha",
  jummah: "Jummah",
  jamaat: "Jama'ah",
};

// Follows the token's case: {ASAR} upper, {asar} lower, {Asar} title case, anything else as written.
export const formatByTokenCase = (value: string, token: string): string => {
  if (!value) return "";
  if (token === token.toUpperCase()) return value.toUpperCase();
  if (token === token.toLowerCase()) return value.toLowerCase();
  if (/^[A-Z][a-z]+$/.test(token)) {
    // Capitalise the first letter, not the first character: "'Asr" must not become "'asr".
    return value.toLowerCase().replace(/\p{Ll}/u, (letter) => letter.toUpperCase());
  }
  return value;
};

// Replaces {fajr} … {jummah} with the masjid's own names, and {jamaat} with the household's
// word for the congregation prayer; other {tokens} are left untouched.
export const applyPrayerNameTokens = (text: string, names?: PrayerNames): string =>
  (text || "").replace(/\{([A-Za-z]+)\}/g, (match, token: string) => {
    const key = token.toLowerCase();
    if (!Object.prototype.hasOwnProperty.call(DEFAULT_NAMES, key)) return match;
    const name = names?.[key as keyof PrayerNames] as string | undefined;
    return formatByTokenCase(name || DEFAULT_NAMES[key], token);
  });
